// Vendor JS — Bootstrap plugins (tree-shaken, only what we use)
// Importing each module also registers its data-API listeners, so declarative
// usage (data-bs-toggle) works without any extra code.
import Alert from 'bootstrap/js/dist/alert';
import Toast from 'bootstrap/js/dist/toast';
import Collapse from 'bootstrap/js/dist/collapse';
import Offcanvas from 'bootstrap/js/dist/offcanvas';

// Expose globally so Stencil (e.g. new bootstrap.Alert / .Toast) and inline
// programmatic usage keep working.
window.bootstrap = { Alert, Toast, Collapse, Offcanvas };

// Project JS
import Stencil from './stencil.js';
window.Stencil = new Stencil();

/**
 * Expose static Stencil methods on the window Stencil instance
 */
Object.getOwnPropertyNames(Stencil)
  .filter(key => typeof Stencil[key] === "function") // Get only static methods
  .forEach(key => window.Stencil[key] = Stencil[key]);

/**
 * Load & define all custom elements in /elements using Webpack custom context
 */
const elementsContext = require.context('./elements', false, /\.js$/);
elementsContext.keys().forEach(file => {
  const moduleName = file.replace('./', '').replace('.js', ''); // Extract name from file
  const module = elementsContext(file);
  customElements.define(moduleName, module.default);
});

/**
 * Register all extensions in /extensions using Webpack custom context
 */
const extensionsContext = require.context('./extensions', false, /\.js$/);
extensionsContext.keys().forEach(file => {
  const moduleName = file.replace('./', '').replace('.js', '').split('-').map(word => word[0].toUpperCase() + word.slice(1).toLowerCase()).join('');
  const module = extensionsContext(file);
  if(module.default.autoregister){
    window.Stencil.registerExtension(new module.default(moduleName));
  }
});

/**
 * Useful global functions
 */
window.debounce = function(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

// Kickoff!
window.Stencil.init();